export default __webpack_public_path__ + "static/media/most-selling.a2c299b5.svg";